import { useApiEffect } from 'framework/hooks/useApiEffect';
import { meta_now } from 'gen/ApiClient';

export const useNow = (): Date | undefined => {
	const [now] = useApiEffect(meta_now);
	return now;
	// return now === undefined ? undefined : formatISO(new Date(now), { representation: 'date' }) as any;
};
